import { IconStar, IconStarFilled } from '@tvg/fuse-icons';
import { buildResponsiveSize } from '@tvg/fuse-utils';
import React from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import styled from 'styled-components';
import { Link } from '../../fuse-link/src/links';
import { TypographyComponent } from '../../fuse-typography-element/src/typography';
import { ratingCssConfig } from './config';

const Container = styled.div.attrs({
	className: 'fuse-rating',
})`
	display: inline-flex;
	flex-wrap: wrap;
`;

const Stars = styled.div`
	${({ rating, size }) => {
		const [isResponsive, setViewportCss] = buildResponsiveSize(size);

		const getAfterHeight = (ratingSize) => `
            height: ${ratingCssConfig[ratingSize]?.height};
        `;
		const getStarsSizeCss = (ratingSize) => {
			const height = ratingCssConfig[ratingSize]?.height;
			// const width = parseFloat(height) * 4.8;
			// const roundedWith = width % 1 !== 0 ? width.toFixed(2) : width;
			const widthFallback = ratingCssConfig[ratingSize]?.widthFallback;

			return `
		        height: ${height};
		        aspect-ratio: 4.8 / 1;

		        @supports not (aspect-ratio: 4.8 / 1) {
		            width: ${widthFallback};
		        }
		    `;
		};

		const setStartContainerSize = () => `
            ${isResponsive ? setViewportCss(getStarsSizeCss) : getStarsSizeCss(size)}
        `;
		const setAfterHeight = () => `
            ${isResponsive ? setViewportCss(getAfterHeight) : getAfterHeight(size)}
        `;

		return `
            position: relative;
            display: inline-block;

            ${setStartContainerSize()}

            margin: 0 var(--spacing-global-space2) 0 0;

            &::before,
            &::after {
                content: '';
                position: absolute;

                top: 0;
                left: 0;
                ${setAfterHeight()}
                width: 100%;

                mask-size: 20%;
                mask-position: center;
            }

            &:before {
                mask-image: url('data:image/svg+xml,${encodeURIComponent(
		renderToStaticMarkup(<IconStar />),
	)}');

                background: linear-gradient(
                    90deg,
                    rgba(0, 0, 0, 0) 0%,
                    rgba(0, 0, 0, 0) ${rating * 20}%,
                    var(--color-global-grey700) ${rating * 20}%
                );
            }

            &:after {
                mask-image: url('data:image/svg+xml,${encodeURIComponent(
		renderToStaticMarkup(<IconStarFilled />),
	)}');

                background: linear-gradient(
                    90deg,
                    var(--color-brand-mid) 0%,
                    var(--color-brand-mid) ${rating * 20}%,
                    rgba(0, 0, 0, 0) ${rating * 20}%
                );
            `;
	}}
`;

const setMarginBottomCss = (ratingSize) => `
    margin-bottom: ${ratingCssConfig[ratingSize]?.marginBottom};
`;

const getMarginBottom = (size) => {
	const [isResponsive, setViewportCss] = buildResponsiveSize(size);

	return isResponsive ? setViewportCss(setMarginBottomCss) : setMarginBottomCss(size);
};

const StyledDiv = styled.div`
	${({ size }) => getMarginBottom(size)}
	display: flex;
	justify-content: center;
	align-items: center;
`;

const StyledLink = styled(Link).attrs({
	underline: true,
})`
	white-space: nowrap;
`;

const StyledReview = styled(TypographyComponent)`
	margin: 0;
`;

export { Container, Stars, StyledDiv, StyledLink, StyledReview };
